export default __webpack_public_path__ + "static/media/logo-white.23ed9c3e.svg";